import React from 'react';
import Hero from '../components/Hero';
import BrandCarousel from '../components/BrandCarousel';
import Features from '../components/Features';
import FacilityTiles from '../components/FacilityTiles';
import NextSteps from '../components/NextSteps';
import SEO from '../components/SEO';

const Home: React.FC = () => {
  return (
    <div className="home">
      {/* ranks for "commissary kitchen" (2,437 impr, pos 10.4), "commercial kitchen for rent" (642, pos 6.0), "rent a kitchen" (247, pos 4.7, ZERO clicks) */}
      <SEO
        title="Kitchen Space for Rent in Vancouver | Rent a Kitchen Hourly"
        description="Rent a kitchen by the hour in Vancouver — licensed commissary kitchen space with no lease and no long-term contract. Pay for the time you use. Apply now."
        keywords="commercial kitchen for rent, commissary kitchen vancouver, rent a kitchen, shared kitchen space, hourly kitchen rental"
      />
      <Hero />
      <BrandCarousel />
      <Features />
      {/* Restored 2026-09-14 on Jeffrey's instruction, reversing the removal
          that came with the 4 June layout on 2026-09-11 (486c03ba). This is
          the only deliberate departure from Sarb's June homepage.
          Why it is back: these tiles were the ONLY internal link to a facility
          landing page anywhere on the site, and the route they carried was the
          best converting one we have — 17 of 41 sessions that went homepage ->
          kitchen page clicked Apply (41%), against 25 of 207 (12%) for homepage
          sessions with no onward hop. After they went the route read zero every
          day measured. CMSY-75 and CMSY-76 restored access from /our-kitchens
          and the footer; this restores the route that actually converted.
          Below the fold and lazy-loaded on purpose — the homepage was once the
          slowest page on the site (CMSY-16) and its six images are ~1.1 MB. */}
      <FacilityTiles />
      <NextSteps />
    </div>
  );
};

export default Home;